import React from "react";
import { Field } from "redux-form";

import type { FilterLocation } from "@js/apps/filters/types";
import { JOB_LOCATION } from "@js/apps/jobs/context";

import type { OrderingType } from "../../config";
import { SortForm } from "../../config";
import { GenericSortButton } from "../generic-sort-button";

const SORTING_OPTIONS_TALENT = [
  { label: "Best match", value: "-score" },
  { label: "Newest", value: "newest" },
] as const;

const SORTING_OPTIONS_JOB = [
  { label: "Newest", value: "-created" },
  { label: "Best match", value: "-score" },
] as const;

type FiltersSortButtonProps = {
  location: FilterLocation;
  defaultValue: OrderingType;
  isBestMatchAvailable?: boolean;
};

const getSortingOptions = ({
  isJobLocation,
  isBestMatchAvailable,
}: {
  isJobLocation: boolean;
  isBestMatchAvailable: boolean;
}) => {
  if (!isJobLocation) {
    return SORTING_OPTIONS_TALENT;
  }

  if (!isBestMatchAvailable) {
    return SORTING_OPTIONS_JOB.filter((option) => {
      return option.value !== "-score";
    });
  }

  return SORTING_OPTIONS_JOB;
};

export const FiltersSortButton = ({
  location,
  defaultValue,
  isBestMatchAvailable = true,
}: FiltersSortButtonProps) => {
  const sortingOptions = getSortingOptions({
    isJobLocation: location in JOB_LOCATION,
    isBestMatchAvailable,
  });

  // There is nothing to choose from with a single sorting option
  if (sortingOptions.length < 2) {
    return null;
  }

  return (
    <SortForm form="filters-sort-button">
      <Field
        name="ordering"
        component={GenericSortButton}
        options={sortingOptions}
        defaultValue={defaultValue}
      />
    </SortForm>
  );
};
